(($) => {
    "use strict";

    $(() => {

        if ($("#mobile__menu").length) {
            $("#mobile__menu").mmenu({
                offCanvas: false,
                navbar: {
                    add: true,
                    title: "<span></span>",
                },
                navbars: [
                    {
                        position: "top",
                        content: [
                            `<img class="brand__logo logo--small mobil-menu-logo" src="${localize.themeurl}/assets/img/svg/logos/brand_logo_orange_black.svg" alt="Cordia">'`,
                            `<span class="mm-btn mm-navbar__btn close-mobile-menu js-close-mobile-menu">
                                <i class="icon-x"></i>
                            </span>`,
                        ],
                    },
                ],
            });

            document.querySelector("#mobile__menu .mm-panel .mm-navbar__title").href = localize.siteurl;

            $(".js-close-mobile-menu").on("click", () => {
                $(".mm-wrapper").removeClass("opened");
                $("html").removeClass("menu-opened");
                $("body").removeClass("menu-opened");
                $(".mm-wrapper").fadeOut();
            });

            $(".js-trigger-mobil-menu").on("click", () => {
                $(".mm-wrapper").addClass("opened");
                $("html").addClass("menu-opened");
                $("body").addClass("menu-opened");
                $(".mm-wrapper").fadeIn();

                $(".js-filters-header,.js-filters-footer,.js-mobile-detailed-filters,.js-map-detailed-filters,.js-map-found-list").removeClass("open");
            });
        }

    });
})(jQuery);
